export default __webpack_public_path__ + "static/media/admin_logo.1ceaf9da.png";